module.exports = __webpack_public_path__ + "img/santander.8a9843b8.png";